import ProgressLabel from 'components/shared/ProgressLabel';
import _ from 'lodash';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Label } from 'semantic-ui-react';

const messages = defineMessages({
  'new': {
    id: 'review.columns.status.new',
    defaultMessage: 'New'
  },
  'inProgress': {
    id: 'review.columns.status.inProgress',
    defaultMessage: 'In Progress'
  },
  'complete': {
    id: 'review.columns.status.complete',
    defaultMessage: 'Complete'
  }
});

const StatusColumn = ({
  review,
  intl: {
    formatMessage
  }
}) => {
  const completed = _.chain(review.trends)
    .filter(reviewTrend =>
      reviewTrend.skipped || !_.find(
        review.regions,
        reviewRegion => !reviewTrend.regions[reviewRegion.name]
      ))
    .size()
    .value();
  if (completed === 0) {
    return (
      <Label content={formatMessage(messages['new'])} />
    );
  };
  
  if (completed === _.size(review.trends)) {
    return (
      <Label
        color='green'
        content={formatMessage(messages['complete'])} />
    );
  };

  return (
    <ProgressLabel
      content={formatMessage(messages['inProgress'])}
      color='yellow'
      percent={100 * completed / _.size(review.trends)} />
  );
};

StatusColumn.displayName = 'StatusColumn';

export default injectIntl(StatusColumn);